<div class="container-full bg-theme">
  <div class="container">
    <div class="columns">
      <div class="column is-12 p-b-xl">
        <div
          class="temporary-item temporary-breadcrumbs"
          *ngIf="!breadcrumbLinks"
        ></div>
        <app-breadcrumbs
          [breadcrumbLinks]="breadcrumbLinks"
          [darkTheme]="true"
        ></app-breadcrumbs>
        <div>
          <h1 class="title is-1 has-text-light">Generative AI</h1>
          <p class="has-text-light m-y-gutter"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-full">
  <div class="subnav has-background-white">
    <div class="container">
      <div class="columns">
        <div class="column py-4">
          <div class="full-width subnav--list">
            <a
              class="button is-small is-white is-ge-ai"
              routerLink="/genai"
              [ngClass]="{ 'is-active': selectedNavItem === 'overview' }"
              >Overview</a
            >
            <a
              class="button is-small is-white is-ge-ai"
              routerLink="/genai/issues/overview"
              [ngClass]="{ 'is-active': selectedNavItem === 'issues' }"
              >The Issues</a
            >
            <a
              class="button is-small is-white is-ge-ai"
              routerLink="/genai/data"
              [ngClass]="{ 'is-active': selectedNavItem === 'data' }"
              >Data</a
            >
            <a
              class="button is-small is-white is-ge-ai"
              routerLink="/genai/publications"
              [ngClass]="{ 'is-active': selectedNavItem === 'resources' }"
              >Resources</a
            >
            <a
              class="button is-small is-white is-ge-ai is-hidden"
              routerLink="/catalogue/overview"
              [ngClass]="{ 'is-active': selectedNavItem === 'tools' }"
              >Tools</a
            >
            <div
              class="is-inline-flex is-full-height is-align-items-center is-justify-content-center ml-6 is-hidden-mobile"
            >
              <a
                class="button is-warning has-text-weight-bold"
                routerLink="/catalogue/tools"
                [queryParams]="{ purposeIds: purposeId }"
              >
                <i
                  class="icon icon-Externallink mr-1"
                  style="top: 2px; position: relative"
                ></i>
                Generative AI tools</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
